import { CLEAR_ERRORS } from "../constants";

export const clearErrors = () => dispatch => {
  dispatch({ type: CLEAR_ERRORS });
};
